import { type FC } from "react";
import { InformationPage } from "~/common/components/informationPage/InformationPage";
import { IMG_QUOTE_CONFIRMATION } from "~/utils/url/staticResources";
import { useTranslation } from "react-i18next";
import { styled } from "~/common/mui";

export interface Props {
  url: string;
  email: string;
  inquiryNumber: string;
  imageSrc?: string;
}

export const ContactUsConfirmationPageView: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <InformationPage
      title={<ConfirmationHeadline>{t("contact.us.confirmation.title")}</ConfirmationHeadline>}
      subtitle={
        <ConfirmationDetails>
          <DetailLine>
            {t("contact.us.confirmation.messageNoLabel")}
            <strong>{props.inquiryNumber}</strong>
          </DetailLine>
          <DetailLine>
            {t("contact.us.confirmation.copySentToLabel")}
            <strong>{props.email}</strong>
          </DetailLine>
        </ConfirmationDetails>
      }
      btnSetup={{
        href: props.url,
        label: t("contactUsConfirmation.continueShopping"),
      }}
      imageSrc={props.imageSrc ?? IMG_QUOTE_CONFIRMATION}
    />
  );
};

const ConfirmationDetails = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  textAlign: "center",
}));

const DetailLine = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(0.625),
  ...theme.typography.titleMedium,
}));

const ConfirmationHeadline = styled("div")(({ theme }) => ({
  ...theme.typography.displaySmall,
  marginBottom: theme.spacing(2.5),
}));

export function createContactUsConfirmationPage(data: Props) {
  return <ContactUsConfirmationPageView {...data} />;
}
